import React from 'react';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useUser from "../hooks/user/useUser";
import { AUTH_VALUES } from "../utils/Constants";

const { ADMIN_LEVEL } = AUTH_VALUES;

const Level11Route = () => {
    const { userState, isLoggedIn } = useUser();
    const { pathname, search } = useLocation();

    if (isLoggedIn) {
        // Verificar que el usuario tenga nivel 11
        if (userState && userState.level && parseInt(userState.level) >= ADMIN_LEVEL) {
            return <Outlet />;
        } else {
            return <Navigate to='/forbidden' state={{ from: pathname, search: search }} />;
        }
    } else {
        return <Navigate to='/iniciar-sesion' state={{ from: pathname, search: search }} />;
    }
};

export default Level11Route;
